import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminGuard from "@/components/admin/AdminGuard";
import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import { captureAttribution } from "@/lib/utm";

function App() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={<Navigate to="/admin/leads" replace />}
            />
            <Route
              path="/admin/leads"
              element={
                <AdminGuard>
                  <AdminLeads />
                </AdminGuard>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AdminAuthProvider>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#F5F1E8",
            border: "1px solid rgba(192,192,192,0.2)",
            borderRadius: 0,
            fontFamily: "Montserrat, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
